import { Component, computed, inject, signal } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import {
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  type DialogComponentI,
} from '@core/user-interface-legacy';

export interface ConfirmLoginChangeDialogData {
  login: string;
  changeByAdmin: boolean;
}

@Component({
  selector: 'rt-confirm-login-change-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe],
  template: `
    <rt-confirm-dialog
      [title]="'tlc.current_user.confirm_username_change_dialog.title' | translate"
      [message]="message()"
      [agreeLabel]="'tlc.common.confirm' | translate"
      [cancelLabel]="'tlc.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
    />
  `,
})
export class ConfirmLoginChangeDialogComponent implements DialogComponentI<
  ConfirmLoginChangeDialogData,
  boolean
> {
  private readonly i18n = inject(I18nService);
  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public login = signal<string>('');
  public changeByAdmin = signal<boolean>(false);

  protected message = computed(() =>
    this.changeByAdmin()
      ? this.i18n.translate(
          'tlc.members.edit_member.account_tab.section.username.confirm_username_change_dialog.agree_text',
          { login: this.login() },
        )
      : this.i18n.translate('tlc.current_user.confirm_username_change_dialog.agree_text', {
          login: this.login(),
        }),
  );

  public setDialogData(data: ConfirmLoginChangeDialogData): void {
    this.login.set(data.login);
    this.changeByAdmin.set(data.changeByAdmin);
  }
}
